import {
  ChildTypeGroupingRule,
  PerspectivesGroupsComponentTypes,
  PerspectivesGroupsWorkspace,
} from '../types';
import { Select } from '@ardoq/select';
import { EmptySpaceFiller, GroupLabel } from './SharedGroupRuleElements';
import { toComponentTypeOption, toWorkspaceOption } from './toOptionsMapper';
import { ArdoqId, GroupType } from '@ardoq/api-types';
import { type I18nLocale, t } from '@ardoq/i18n';

type ChildTypeGroupRuleProps = {
  groupingRule: ChildTypeGroupingRule;
  workspaces: PerspectivesGroupsWorkspace[];
  componentTypesPerWorkspace: Record<
    ArdoqId,
    PerspectivesGroupsComponentTypes[]
  >;
  i18nLocale: I18nLocale;
};

/**
 * @deprecated
 * This grouping rule has been deprecated and user can only use it if it is a part of Saved perspective.
 * Creating a new Child grouping rule is no longer possible.
 * This rule is read-only and cannot be updated.
 */
const ChildGroupRule = ({
  workspaces,
  groupingRule,
  componentTypesPerWorkspace,
  i18nLocale,
}: ChildTypeGroupRuleProps) => {
  const workspaceOptions = workspaces.map(workspace =>
    toWorkspaceOption(workspace)
  );

  const componentTypes =
    componentTypesPerWorkspace[groupingRule.workspaceId!] ?? [];
  const componentTypeOptions = componentTypes.map(toComponentTypeOption);

  return (
    <>
      <GroupLabel data-testid={`group-by-${GroupType.CHILD}-label`}>
        {t(i18nLocale, 'perspectives:groupingRules.childLabel', 'Child')}
      </GroupLabel>
      <Select
        dataTestId="child-grouping-rule-workspace-select"
        value={groupingRule.workspaceId}
        options={workspaceOptions}
        aria-label={t(
          i18nLocale,
          'perspectives:groupingRules.workspaceAriaLabel',
          'Workspace'
        )}
        isDisabled
      />
      <Select
        aria-label={t(
          i18nLocale,
          'perspectives:groupingRules.componentTypesAriaLabel',
          'Component types'
        )}
        dataTestId="child-grouping-rule-component-type-select"
        options={componentTypeOptions}
        value={groupingRule.targetId}
        isDisabled
      />
      <EmptySpaceFiller />
      <EmptySpaceFiller />
    </>
  );
};

export { ChildGroupRule };
